module.exports = __webpack_public_path__ + "static/media/Google_Docs_Logo.c647b486.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/ai/icons/Google_Docs_Logo.svg
// module id = 3692
// module chunks = 0